import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import TailNumberReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/tail-number.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(TailNumberReducer, defaultState, asyncActions);
};

type ITailNumberContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const TailNumberContext = createContext<Partial<ITailNumberContext>>({
  state: defaultState,
}) as React.Context<ITailNumberContext>;

const TailNumberProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <TailNumberContext.Provider value={{ ...reducer }}>
      {children}
    </TailNumberContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useTailNumberContext = () => useContext(TailNumberContext);

export type IUseTailNumberContext = ReturnType<typeof useTailNumberContext>;

export { TailNumberContext, TailNumberProvider };
